import { createFileRoute, Link } from "@tanstack/react-router";
import { buildBreadcrumbs } from "@/components/SchemaJsonLd";
import { PageHero } from "@/components/PageHero";
import { CTASection } from "@/components/CTASection";
import { SectionHeading } from "@/components/SectionHeading";
import { ArrowRight } from "lucide-react";
import flakeImg from "@/assets/flake-closeup.jpg";

const RESOURCES = [
  { slug: "garage-floor-coating-cost", title: "Garage Floor Coating Cost Guide", desc: "Real Calgary Region pricing for every coating system — flake, metallic, polyaspartic, and grind-and-seal." },
  { slug: "epoxy-vs-polyaspartic", title: "Epoxy vs Polyaspartic", desc: "Side-by-side comparison: cure time, UV stability, durability, and cost." },
  { slug: "garage-floor-coating-colors", title: "Garage Floor Coating Colors", desc: "Flake blends, metallic palettes, and solid colors with visual examples." },
  { slug: "garage-floor-coating-maintenance", title: "Maintenance Guide", desc: "How to clean, care for, and extend the life of your coated floor." },
];

export const Route = createFileRoute("/resources/")({
  head: () => ({
    meta: [
      { title: "Garage Floor Coating Resources | MLC Epoxy Floors" },
      { name: "description", content: "In-depth resources on garage floor coatings — pricing, epoxy vs polyaspartic, color options, and maintenance guides." },
      { property: "og:title", content: "Resources | MLC Epoxy Floors" },
      { property: "og:description", content: "Pricing, comparisons, color galleries, and maintenance guides for epoxy and polyaspartic floors." },
      { property: "og:url", content: "/resources" },
    ],
    links: [{ rel: "canonical", href: "/resources" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(buildBreadcrumbs([
        { name: "Home", href: "/" },
        { name: "Resources", href: "/resources" },
      ])) },
    ],
  }),
  component: () => (
    <>
      <PageHero eyebrow="Resources" title="Learn Before You Coat" body="Pricing breakdowns, system comparisons, color galleries, and maintenance guides — written by the Calgary region's coating specialists." image={flakeImg} />
      <section className="container-x py-20">
        <SectionHeading eyebrow="Guides" title="In-Depth Resources" />
        <div className="mt-12 grid gap-6 md:grid-cols-2">
          {RESOURCES.map((r) => (
            <Link key={r.slug} to={`/resources/${r.slug}` as string} className="group rounded-sm border border-border bg-charcoal p-7 hover:border-copper">
              <p className="text-xl text-silver-light group-hover:text-copper">{r.title}</p>
              <p className="mt-2 text-silver">{r.desc}</p>
              <span className="mt-4 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-copper">Read <ArrowRight className="h-3.5 w-3.5" /></span>
            </Link>
          ))}
        </div>
      </section>
      <CTASection />
    </>
  ),
});
